module.exports = __webpack_public_path__ + "static/media/nodat-img.1dc5ba3c.jpg";